import axios from 'axios'

import { Area, ChanneledRequestParams } from 'types'

export const getAreas = async (params: ChanneledRequestParams) => {
  return (
    await axios.get<Area[]>('/areas', {
      params,
    })
  ).data
}
